import React from 'react'
import { AmountOverrideDto } from '@/api/Wallet/Types/WithdrawalAutomationDto'
import { GridCellProps } from '@progress/kendo-react-grid'

import { enabledColumn, GridColumn, scopeColumns } from './OverrideScopeColumns'

const AmountsCell: React.FC<GridCellProps> = ({ dataItem }) => (
  <td>
    {(dataItem.limits as AmountOverrideDto['limits'])
      .map((limit) => `${limit.maxAmount} ${limit.currencyId}`)
      .join(' / ')}
  </td>
)

const amountOverridesColumns: GridColumn[] = [
  ...scopeColumns,
  { title: 'Amounts', field: 'limits', cell: AmountsCell, show: true },
  enabledColumn,
]

export default amountOverridesColumns
